<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="flex flex-wrap max-h-full bg-white shadow-lg rounded-lg w-3/6 px-5 pb-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 z-50 bg-white pt-5">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="w-full px-4 py-2 h-full">
          <div class="w-full">
            <div class="flex">
              <h1
                class="pb-1 text-left font-bold tracking-widest text-neutral-100"
              >
                {{ currentProject.titulo }}
              </h1>
            </div>
<!--             <div class="flex">
              <div class="h-80 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="4"
                  :center="center"
                  :options="{ zoomControl: false }"
                  @ready="onMapReady"
                >
                        <l-tile-layer
                    :url="urlBasemap"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
                </l-map>
              </div>
            </div> -->
            <div class="flex w-full">
              <div
                class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
              >
                <div class="flex items-center">
                  <div class="flex items-center w-1/2 text-left text-xs">
                    <div
                      v-if="currentProject.status === 'NO REVISADO'"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} EN PROCESO
                    </div>
                    <div
                      v-if="currentProject.status === 'RECHAZADO'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'EN REVISIÓN'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'APROBADO'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div class="pl-2">
                      <div
                        v-if="currentProject.activo === true"
                        class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                      >
                        Activo
                      </div>
                      <div
                        v-if="currentProject.activo === false"
                        class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                      >
                        Desactivado
                      </div>
                    </div>
                  </div>
                  <div class="w-1/2 text-right text-xs text-gray-900">
                    {{
                      currentProject.fecha_creacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Nombre del proyecto:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Institución:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.institucion }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Nombre de quien propone:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.lider }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Descripción:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.descripcion }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Objetivo:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.objetivo }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold"
                      >Especificaciones multimedia:</span
                    >
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.especificaciones_multimedia }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Producto:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.producto }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Creado por:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_propietario }}
                    {{ currentProject.apellido_propietario }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de creación:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{
                      currentProject.fecha_creacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Desactivado por:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_curador_desactivate }}
                    {{ currentProject.apellido_curador_desactivate }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de desactivación:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{
                      currentProject.fecha_desactivacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.id_curador !== null"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span
                      class="font-bold"
                      v-if="currentProject.status !== 'NO REVISADO'"
                      >Atendido por:</span
                    >
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_curador }}
                    {{ currentProject.apellido_curador }}
                  </div>
                </div>

                <div
                  v-if="currentProject.file_type == 'video/mp4'"
                  class="flex justify-center py-2 w-full"
                >
                  <video
                    :src="currentProject.path_media_folder"
                    width="640"
                    height="480"
                    controls
                    controlslist="nodownload"
                  />
                </div>
                <div class="flex justify-center py-2 w-8/12 mx-auto">
                  <v-lazy-image :src="currentProject.path_media_folder" />
                </div>
                <p
                  v-if="currentProject.ficha_proyecto"
                  class="pb-1 pt-2 text-sm text-left font-bold tracking-widest"
                >
                  Ficha de información:
                </p>
                <div
                  v-for="(one_question, index) in currentQuestions"
                  :key="'q_' + index"
                  :class="nestedStatusFicha[index] ? 'pl-6 border-l-4 border-gray-300 ml-2 mb-4' : 'mb-4'"
                >
                  <div v-if="one_question.tipo === 'SECCION'" class="w-full mb-2 bg-gray-200 border-l-4 border-gray-500 p-2 rounded shadow-sm">
                    <label class="block uppercase tracking-wider text-gray-800 text-sm font-bold text-left">
                      <template v-if="one_question.numero_pregunta">{{ one_question.numero_pregunta }}.- </template>{{ one_question.texto }}
                      <template v-if="one_question.nota_para_registrante">
                        ({{ one_question.nota_para_registrante }})
                      </template>
                    </label>
                  </div>
                  <div v-else-if="one_question.texto != null">
                    <label
                      class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                      ><template v-if="one_question.numero_pregunta">{{ one_question.numero_pregunta }}.-</template>
                      {{ one_question.texto }}
                      <template v-if="one_question.nota_para_registrante != ''">
                        ({{ one_question.nota_para_registrante }})
                      </template>
                    </label>

                    <div v-if="one_question.tipo === 'ABIERTA'">
                      <input-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        value=""
                        disabled
                        :colorT="colorT"
                      />
                    </div>

                    <template v-if="one_question.tipo == 'SELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>
                    </template>

                    <template
                      v-if="one_question.tipo == 'SELECCION_CONDICIONAL'"
                    >
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            :value="opt"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <template
                        v-for="(opt, index) in one_question.pregunta_condicion"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.id }}.-
                          {{ opt.texto }}
                          "{{ index }}"
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <template v-for="(opt1, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt1 }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <div v-if="opt.tipo === 'ABIERTA'">
                          <input-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="colorT"
                          />
                        </div>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <template v-for="(opt1, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt1.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="colorT"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>

                    <template v-if="one_question.tipo == 'OPCION_SEGUIMIENTO'">
                      <div v-for="(concepto, cIdx) in one_question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                        <div class="flex items-center gap-4 text-gray-700 font-bold mb-2">
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_si }}</span>
                          </div>
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_no }}</span>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-if="one_question.tipo == 'CAMPOS' || one_question.tipo == 'GRUPO_REPETIBLE' || one_question.tipo == 'MINI_FORMULARIO'">
                      <template v-for="(opt, index) in one_question.campos">
                        <div class="flex w-full items-center justify-center">
                          <label
                            class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >{{ opt.texto }}</label
                          >
                          <input-styled
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="colorT"
                          />
                        </div>
                      </template>
                    </template>
                    <template v-if="one_question.tipo == 'MATRIZ'">
                        <div class="overflow-x-auto mb-3 pl-4">
                          <table class="w-full text-left border-collapse">
                            <thead>
                              <tr>
                                <th class="border-b-2 p-2"></th>
                                <th
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'col_' + colIdx"
                                  class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                                >
                                  {{ col }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(fila, idx) in (one_question.filas || [])"
                                :key="'fila_' + idx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'td_' + idx + '_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input type="radio" disabled class="leading-tight" />
                                </td>
                              </tr>
                              <tr v-if="one_question.otro">
                                <td class="border-b p-2 text-sm text-gray-500 italic">
                                  Otro (opcional)
                                </td>
                                <td
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'td_otro_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input type="radio" disabled class="leading-tight" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </template>

                    <template v-if="one_question.hasOwnProperty('subpregunta')">
                      <template
                        v-for="(opt, index) in one_question.subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          ><span v-if="opt.numero_pregunta">{{ opt.numero_pregunta }}.-</span>
                          {{ opt.texto }}
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>
                        <div v-if="opt.tipo === 'ABIERTA'">
                          <input-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="colorT"
                          />
                        </div>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <template v-for="(opt, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <template v-for="(opt, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="colorT"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                    <div v-if="one_question.tipo === 'FECHA'">
                      <div class="w-1/2 lg:w-2/3 px-3 mb-6 md:mb-0">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-gray-200 focus:select-none"
                          type="date"
                          name="question"
                          v-on:click.prevent=""
                        />
                      </div>
                    </div>
                    <div v-if="one_question.tipo === 'FOTO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-gray-200 focus:select-none"
                          type="file"
                          accept="image/*"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import moment from "moment";

import { styled } from "@egoist/vue-emotion";

const InputStyled = styled("input")`
  border-color: ${props => props.colorT};
`;

export default {
  name: "project-detail-modal",
  data() {
    return {
      currentQuestions: {},
      currentProject: {},
      report: null,
      information: null,
      errors: {
        report: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      zoom: 12,
      center: [20.58651, -89.01501],
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    colorP: {
      required: true
    },
    colorS: {
      required: true
    },
    colorT: {
      required: true
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("showProjectDetail", this.setData);
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
    InputStyled
  },
  computed: {
    nestedStatusFicha() {
      let inSection = false;
      if (!this.currentQuestions) return [];
      return this.currentQuestions.map(q => {
        if (q.tipo === 'SECCION') {
          inSection = true;
          return false;
        }
        return inSection;
      });
    }
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
      });
    },

    reset: function () {
      this.geojsonRouter = null;
      (this.report = null),
        (this.information = null),
        (this.currentProject = {}),
        (this.currentQuestions = {}),
        (this.errors = {
          report: false,
          codeError: "Ha ocurrido un error"
        });
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData(data) {
      this.information = Object.assign({}, data);
      this.fetchProyect();
    },

    fetchProyect() {
      this.$root.$emit("showLoading");
      this.axios
        .get(
          `apidev/projects/getInfoProject/${this.information.id_proyecto}`,
          {},
          this.config
        )
        .then(response => {
          this.currentProject = response.data.answers;
          this.showPolygonInMap();
          return this.axios.post(
            "apidev/projects/getFichaRespuestasJson",
            {
              id_project: this.information.id_proyecto
            },
            this.config
          );
        })
        .then(response => {
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");
        })
        .catch(error => this.catchError(error));
    },

    showPolygonInMap() {
      if (this.currentProject.geometria !== null) {
        if (this.currentProject.kml != null) {
          const type = this.currentProject.kml.split(".")[1];
          if (type == "kml") {
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText);
            });
            oReq.open("GET", "apidev/" + this.currentProject.kml);
            oReq.send();
          }

          if (type == "kmz") {
            this.resetFileGeometryInMap();
            this.kmzParser.load("apidev/" + this.currentProject.kml);
          }
        } else {
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if (this.geojsonRouter) {
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            this.$refs.map.mapObject.fitBounds(boundingBox);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }
    },

    resetFileGeometryInMap() {
      if (this.layerKmz != null) {
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if (this.layerKml != null) {
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
